import {useTranslation} from 'react-i18next'
import {buildSearchParams, TAppLinkProps} from './utils'
import {useRootLoaderData} from '~/utils/useRootLoaderData'
import {SupportedLanguage} from '~/utils/locales'

export const TAppLink = ({to, queryParams, customLocale, ...props}: TAppLinkProps) => {
  const {i18n} = useTranslation()
  const {env} = useRootLoaderData()

  const effectiveLocale = customLocale || (i18n.language as SupportedLanguage)

  const {searchString} = buildSearchParams({
    queryParams,
    isAppUrl: true,
    locale: effectiveLocale
  })
  const rel = props.target === '_blank' ? 'noopener noreferrer' : undefined

  const href = `${env.laraAppUrl}${to}${searchString}`
  return <a {...props} href={href} rel={rel} />
}
